import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFoundPage() {
  return (
    <>
      <Seo title="404 — Strona nie znaleziona | BEAUTIX Katowice" description="Ta strona nie istnieje." />
      <section className="min-h-[60vh] flex items-center justify-center px-6 text-center">
        <div>
          <p className="eyebrow mb-6">404</p>
          <h1 className="font-serif-display text-5xl md:text-7xl leading-[1.05] mb-6">
            Ta strona <span className="italic text-[var(--beautix-pink)]">nie istnieje</span>.
          </h1>
          <p className="text-lg text-[var(--beautix-muted)] max-w-lg mx-auto mb-10">
            Spróbuj wrócić do strony głównej lub odwiedź jedną z naszych podstron
            z usługami.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-3 bg-[var(--beautix-pink)] hover:bg-[var(--beautix-pink-dark)] text-white px-8 py-4 rounded-full text-sm font-medium tracking-wide transition-colors"
            data-testid="back-home-404"
          >
            Wróć na stronę główną
          </Link>
        </div>
      </section>
    </>
  );
}
